import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query';
import dayjs from 'dayjs';

import type { MyNotificationsListQuery } from '@schema/main';

import APIold from '@api/graphqlOld';

type NotificationsPageT = MyNotificationsListQuery['myNotificationsList'];

export type NotificationItemT = NonNullable<
  NotificationsPageT['itemsList']
>[number];

export const NOTIFICATIONS_QUERY_KEY = 'notifications';

/**
 * Счётчик непрочитанных уведомлений. Без staleTime — всегда свежий,
 * кэш дедуплицирует только параллельные запросы; observable-зеркало
 * живёт в UserStore на переходный период.
 */
export const notCheckedNotificationsAmountQueryOptions = () =>
  queryOptions({
    queryKey: [NOTIFICATIONS_QUERY_KEY, 'notCheckedAmount'],
    queryFn: () => APIold.notCheckedNotificationsAmount()
  });

export const notificationsInfiniteQueryOptions = (filter = '') =>
  infiniteQueryOptions({
    queryKey: [NOTIFICATIONS_QUERY_KEY, filter],
    queryFn: ({ pageParam }) =>
      APIold
        .myNotificationsList({
          parameters: { type: '', eppOffset: pageParam, filter }
        })
        .then(res => res.myNotificationsList),
    initialPageParam: 0,
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      const pageSize = lastPage.itemsList?.length || 0;
      const loaded = lastPageParam + pageSize;
      const total = lastPage.itemsTotal || 0;
      return pageSize > 0 && loaded < total ? loaded : undefined;
    },
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false
  });

export type GroupedNotificationsT = Record<
  string,
  Record<string, NotificationItemT[]>
>;

export const groupNotificationsByYearMonth = (
  items: NotificationItemT[]
): GroupedNotificationsT => {
  const groups: GroupedNotificationsT = {};
  items.forEach(item => {
    const parsed = dayjs(item.date);
    const year = parsed.format('YYYY');
    const month = parsed.format('M');
    const formatted = { ...item, date: parsed.format('DD MMMM YYYY') };
    groups[year] = groups[year] || {};
    groups[year][month] = [...(groups[year][month] || []), formatted];
  });
  return groups;
};
